import ActiveResponseProcedures from '../components/CrisisResponse/ActiveResponseProcedures';

export default function CrisisResponse() {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Crisis Response</h2>
      <div className="bg-white p-6 rounded-lg shadow">
        <ActiveResponseProcedures />
      </div>
    </div>
  );
}